import _, { add, reject } from "lodash";
import moment from "moment";
import axios from 'axios';

export const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
};

const axiosPincodeInfoUtility = axios.create({
  baseURL: process.env.REACT_APP_Base_Url,
  timeout: 120000,
  headers: { 'Content-Type': 'application/json',  }
});

class HTTPRequest {
  static GET = (type, url) => {
    return new Promise(async (resolve, reject) => {
      try {
        let utility = null;
        if (type == "pincode") {
          utility = axiosPincodeInfoUtility;
        } 
        if (utility == null) {
          return;
        }
        const response = await utility.get(url);
        
        if (typeof response == "string") {
          response = JSON.parse(response);
          // dispatch(updateQQPlanState(response)) //todo: once APIs are up
        }
        if (response.data != null && response.status == 200) {
          resolve(response.data);
        } else {
          reject(response);
        }
      } catch (error) {
        console.log(
          "HTTPRequest error: " + url + " : " + JSON.stringify(error)
        );
        reject(error);
      }
    });
  };
}

export {
  HTTPRequest,
};